module.exports = __webpack_public_path__ + "img/smiling-cat-with-heart-eyes.1ee884f0.png";